import axios from 'axios'
import {Message} from 'element-ui'
import router from '../router'
import Cookies from 'js-cookie'; //引入cookie操作依赖
const service = axios.create({
  timeout: 1000 * 30,
  // 允许跨域带token
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    accesstoken:''
  }
})
// request请求拦截器
service.interceptors.request.use(
  (config) => {
    // let token = window.localStorage.getItem('accesstoken');
    let token = Cookies.get('aipeopletoken');
    if (token) {
      config.headers.accesstoken = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  })


// response响应拦截器
service.interceptors.response.use(response => {
  if (response.data.errCode === 40405) {
    Cookies.remove('aipeopletoken');
    Cookies.remove('aiAccount');
    router.push({
      path: '/index',
    })
    window.localStorage.clear()
    window.sessionStorage.clear()
  }else if (response.data.errCode == 0){

  }else{
    Message({
      message: response.data.errMsg,
      type: 'error',
    })
  }
  if (response.headers.authorization) {
    // window.localStorage.setItem('accesstoken', response.headers.authorization);
    Cookies.set('aipeopletoken', response.headers.authorization);
  }
  return response.data
}, error => {
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    // alert('请求超时,请稍后再试!');
    Message({
      message: '请求超时,请稍后再试!',
      type: 'error',
    })
    console.log('根据你设置的timeout/真的请求超时 判断请求现在超时了，你可以在这里加入超时的处理方案')
  }
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/api/interceptors.js